import React, { useState } from 'react';
import { useViewlogies } from 'context';
import { getCorrectedUrl } from '../../utils.js';
import Obituary from 'components/Obituary';
import DonationButton from './DonationButton';
import DonationBox from './DonationBox.js';
import PlantATree from './PlantATree.js';
import './banner.scss';

const reduceOpacity = color => {
    const hex = color.replace(/^#/, '');

    // Parse r, g, b values
    let bigint = parseInt(hex, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;

    return `rgba(${r}, ${g}, ${b}, ${0.9})`;
};

const Donations = () => {
    const { isMobile } = useViewlogies();

    return (
        <div className="donation-container">
            {isMobile && <PlantATree />}

            <Obituary />

            <DonationBox />
        </div>
    );
};

export default Donations;
